export var SessionStorageActionTypes;
(function (SessionStorageActionTypes) {
    SessionStorageActionTypes["SET_APOLLO_SESSION_STORAGE_KEYS"] = "SET_APOLLO_SESSION_STORAGE_KEYS";
})(SessionStorageActionTypes || (SessionStorageActionTypes = {}));
